$(document).ready( function(){
    if ($('.alert-notice').length > 0) {

        CloseNotice();
        //RePositionHamburgerIfNotice();

        /**
         * Animates the notice away and triggers ajax function to set session state to notice closed
         **/
        function CloseNotice() {
            var notice = $('.alert-notice');
            var absoluteBase = notice.attr('data-absolutebase');
            var currentLink = notice.attr('data-currentlink');

            if (currentLink == absoluteBase) { // if home page append /home/
                currentLink = absoluteBase + '/home';
            }

            var allowedAction = '/setNoticeStateToClosed'; // function on AlertNoticePageControllerExtension

            // on click of the close button
            notice.find('.close').on('click', function (evt) {

                // animate the notice away
                notice.slideUp();

                // fire ajax to call allowedAction to set session state to notice closed
                $.ajax({
                    url: currentLink + allowedAction,
                    type: 'POST',
                    data: {},
                    response: function (response) {
                        console.log(response);
                    }
                });
            });
        }


        /**
         * Reposition the sticky hamburger menu to compensate for the height of the notice
         **/
        function RePositionHamburgerIfNotice() {
            var noticeHeight = Math.round($('.alert-notice').height());
            var hamburgerMenu = $('.hamburglar');

            var hamburgerOriginalTopPosition = parseInt($(hamburgerMenu).css('top'));
            var hamburgerNewTopPostition = hamburgerOriginalTopPosition + noticeHeight;

            // on load - if clear of notice height adopt normal position, otherwise position to add on the height of the notice
            if ($(window).scrollTop() < noticeHeight) {
                hamburgerMenu.css('top', hamburgerNewTopPostition);
            } else {
                hamburgerMenu.css('top', hamburgerOriginalTopPosition);
            }

            // on scroll - if clear of notice height adopt normal position, otherwise position to add on the height of the notice
            $(window).scroll(function () {
                if (!$('.alert-notice').hasClass('hidden')) {
                    if ($(window).scrollTop() < noticeHeight) {
                        hamburgerMenu.css('top', hamburgerNewTopPostition - $(window).scrollTop());
                    } else {
                        hamburgerMenu.css('top', hamburgerOriginalTopPosition);
                    }
                }
            });

            // change the sticky hamburger to its original position on close of notice
            $('.alert-notice').find('.close').on('click', function (evt) {
                hamburgerMenu.css('top', hamburgerOriginalTopPosition);
                hamburgerNewTopPostition = hamburgerOriginalTopPosition;
                $('.alert-notice').addClass('hidden');
            });
        }
    }

});